import { render, staticRenderFns } from "./tabMBL.vue?vue&type=template&id=0160b001&scoped=true&"
import script from "./tabMBL.vue?vue&type=script&lang=js&"
export * from "./tabMBL.vue?vue&type=script&lang=js&"
import style0 from "./tabMBL.vue?vue&type=style&index=0&id=0160b001&lang=scss&scoped=true&"
import style1 from "./tabMBL.vue?vue&type=style&index=1&id=0160b001&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0160b001",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0160b001')) {
      api.createRecord('0160b001', component.options)
    } else {
      api.reload('0160b001', component.options)
    }
    module.hot.accept("./tabMBL.vue?vue&type=template&id=0160b001&scoped=true&", function () {
      api.rerender('0160b001', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabMBL.vue"
export default component.exports